import { Component } from 'react';
import { isEmpty, getAvatarName, getColorIndex } from '../../../helpers/common';
import { UserInterface } from '../../../interfaces/chatMessageInterface';
import { randomColorsArray } from '../../../global/row';
import { ChatBoxGroup, ChatBoxWrapper, TextWrapper, UserLogo, UserLogoWrapper } from './styles';
import UserPreferenceSingleton from '../../../helpers/userPreferenceSingleton';

interface Props {
  imgSrc: string;
  size?: number;
  name: string;
  users?: UserInterface[];
}

class ChatBoxAvatar extends Component<Props> {
  renderUserLogoOrText = (
    user: UserInterface | undefined,
    size: number | undefined,
    additionalProps: Record<string, unknown>
  ) => {
    const singleLetter = !!(this.props.users && this.props.users.length > 2); // !! converts to boolean
    const avatarName = getAvatarName(user?.name || '', singleLetter);
    const colorIndex = getColorIndex(avatarName);
    const randColor = randomColorsArray[colorIndex];
    return !isEmpty(user?.profile_photo) ? (
      <UserLogo size={size} src={user?.profile_photo} alt={user?.name || ''} {...additionalProps} />
    ) : (
      <TextWrapper size={size} randColor={randColor} {...additionalProps}>
        <span>{avatarName}</span>
      </TextWrapper>
    );
  };

  render() {
    const { size, users } = this.props;
    const currentUser = UserPreferenceSingleton.getInstance().getCurrentUser();
    const groupUser = users?.filter((user) => user?.id !== currentUser?.id);

    return (
      <UserLogoWrapper>
        <ChatBoxWrapper size={size}>
          {this.renderUserLogoOrText(groupUser?.[0], size, {
            isLeft: users && users?.length > 2
          })}

          {users && users?.length > 2 && (
            <ChatBoxGroup size={size}>
              {this.renderUserLogoOrText(groupUser?.[1], size, {
                isRight: true,
                isImageTop: users && users?.length > 3
              })}

              {users?.length > 3 &&
                this.renderUserLogoOrText(groupUser?.[2], size, {
                  isRight: true,
                  isImageBottom: true
                })}
            </ChatBoxGroup>
          )}
        </ChatBoxWrapper>
      </UserLogoWrapper>
    );
  }
}

export default ChatBoxAvatar;
